// extracted by mini-css-extract-plugin
export default {"button":"delete-icon_button__MoA7l"};